import axios from 'axios'
import moment from 'moment'
import qs from 'qs'

export async function patchUser(userId, body) {
    return axios
        .patch(`${process.env.API_URL}/users/${userId}`, body)
        .then(response => response.data)
}

export async function getFileForExport(params) {
    const dateNow = moment(new Date()).format('DD.MM.YYYY')
    const timeNow = moment(new Date()).format('HH:mm')
    params = { ...params, dateNow, timeNow }

    const apiUrl = params.roleExport ? '/roles/export' : '/users/export'
    delete params.roleExport

    const response = await axios
        .get(`${process.env.API_URL}${apiUrl}`, {
            responseType: 'blob',
            params,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })
        .catch(err => {
            console.error(err)
            return null
        })
    return response?.data
}
